var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showUrgentAlertModal,
          expression: "showUrgentAlertModal",
        },
      ],
    },
    [
      _c("div", { staticClass: "urgent_modal" }, [
        _c("div", { staticClass: "overlay" }),
        _c("div", { staticClass: "urgent_modal_position" }, [
          _c("div", { staticClass: "urgent-alert-card" }, [
            _c(
              "div",
              { staticClass: "urgent-alert-card-inner" },
              [
                _vm.modal_list.length > 1
                  ? _c(
                      "Flicking",
                      {
                        staticStyle: { height: "100%" },
                        attrs: {
                          options: { circular: true },
                          plugins: _vm.plugins,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "viewport",
                              fn: function () {
                                return [
                                  _c("span", {
                                    staticClass:
                                      "flicking-arrow-prev is-circle",
                                  }),
                                  _c("span", {
                                    staticClass:
                                      "flicking-arrow-next is-circle",
                                  }),
                                  _c("div", {
                                    staticClass: "flicking-pagination",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          859150525
                        ),
                      },
                      _vm._l(_vm.modal_list, function (modal, i) {
                        return _c(
                          "div",
                          { key: i, staticClass: "urgent_modal_layout" },
                          [
                            _c("div", { staticClass: "contents" }, [
                              _c("div", {
                                staticClass: "urgent_title",
                                domProps: { innerHTML: _vm._s(modal.title) },
                              }),
                              modal.content.sub_title !== "" &&
                              modal.type === "urgent"
                                ? _c(
                                    "div",
                                    { staticClass: "urgent_title_second" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(modal.content.sub_title) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : modal.content.sub_title !== ""
                                ? _c(
                                    "div",
                                    { staticClass: "urgent_title_second2" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(modal.content.sub_title) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              modal.type === "urgent"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "urgent_modal_content first-second mt-5 mb-4",
                                    },
                                    [
                                      modal.content.content_first
                                        ? _c("div", {
                                            staticClass: "first mt-3",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                modal.content.content_first
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "urgent_modal_content2" },
                                    [
                                      modal.content.content_first
                                        ? _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                modal.content.content_first
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      modal.content.content_first_button
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "urgent_modal_btn",
                                              attrs: {
                                                href: modal.content
                                                  .content_first_url,
                                                target:
                                                  modal.content
                                                    .content_first_external,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  modal.content
                                                    .content_first_button
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                            ]),
                            _c("div", { staticClass: "contents" }, [
                              modal.content.second_title
                                ? _c("div", {
                                    staticClass: "urgent_title",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        modal.content.second_title
                                      ),
                                    },
                                  })
                                : _vm._e(),
                              modal.type === "notice" &&
                              modal.content.content_second
                                ? _c(
                                    "div",
                                    { staticClass: "urgent_modal_content2" },
                                    [
                                      modal.content.content_second
                                        ? _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                modal.content.content_second
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      modal.content.content_second_button
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "urgent_modal_btn",
                                              attrs: {
                                                href: modal.content
                                                  .content_second_url,
                                                target:
                                                  modal.content
                                                    .content_second_external,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  modal.content
                                                    .content_second_button
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            modal.type === "urgent" &&
                            modal.content.content_third
                              ? _c("div", {
                                  staticClass: "urgent_modal_content third",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      modal.content.content_third
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    )
                  : _c(
                      "div",
                      _vm._l(_vm.modal_list, function (modal, i) {
                        return _c(
                          "div",
                          { key: i, staticClass: "urgent_modal_layout" },
                          [
                            _c("div", { staticClass: "contents" }, [
                              _c("div", {
                                staticClass: "urgent_title",
                                domProps: { innerHTML: _vm._s(modal.title) },
                              }),
                              modal.content.sub_title !== "" &&
                              modal.type === "urgent"
                                ? _c(
                                    "div",
                                    { staticClass: "urgent_title_second" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(modal.content.sub_title) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : modal.content.sub_title !== ""
                                ? _c(
                                    "div",
                                    { staticClass: "urgent_title_second2" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(modal.content.sub_title) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              modal.type === "urgent"
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "urgent_modal_content first-second mt-5 mb-4",
                                    },
                                    [
                                      modal.content.content_first
                                        ? _c("div", {
                                            staticClass: "first mt-3",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                modal.content.content_first
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "urgent_modal_content2" },
                                    [
                                      modal.content.content_first
                                        ? _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                modal.content.content_first
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      modal.content.content_first_button
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "urgent_modal_btn",
                                              attrs: {
                                                href: modal.content
                                                  .content_first_url,
                                                target:
                                                  modal.content
                                                    .content_first_external,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  modal.content
                                                    .content_first_button
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                            ]),
                            _c("div", { staticClass: "contents" }, [
                              modal.content.second_title
                                ? _c("div", {
                                    staticClass: "urgent_title",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        modal.content.second_title
                                      ),
                                    },
                                  })
                                : _vm._e(),
                              modal.type === "notice" &&
                              modal.content.content_second
                                ? _c(
                                    "div",
                                    { staticClass: "urgent_modal_content2" },
                                    [
                                      modal.content.content_second
                                        ? _c("div", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                modal.content.content_second
                                              ),
                                            },
                                          })
                                        : _vm._e(),
                                      modal.content.content_second_button
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "urgent_modal_btn",
                                              attrs: {
                                                href: modal.content
                                                  .content_second_url,
                                                target:
                                                  modal.content
                                                    .content_second_external,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  modal.content
                                                    .content_second_button
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            modal.type === "urgent" &&
                            modal.content.content_third
                              ? _c("div", {
                                  staticClass: "urgent_modal_content third",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      modal.content.content_third
                                    ),
                                  },
                                })
                              : _vm._e(),
                          ]
                        )
                      }),
                      0
                    ),
                _c("div", { staticClass: "urgent_modal_footer" }, [
                  _c(
                    "span",
                    {
                      staticClass: "no_more_modal",
                      on: { click: _vm.noMoreUrgentAlert },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("modal.urgent.seven")) +
                          "\n            "
                      ),
                    ]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "no_more_modal just_close",
                      on: {
                        click: function ($event) {
                          return _vm.$store.commit("toggleUrgentAlertModal", {
                            state: false,
                          })
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("modal.close")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }